import isZocdocBrand from '../../utils/isZocdocBrand';

export default function getPageViewData({ theme, location }) {
    if (!isZocdocBrand(theme.directoryId)) {
        const page = `[${location.hostname}]${location.pathname}`;

        return {
            page,
            isWhiteLabel: true,
            whiteLabelName: theme.formalName,
            strategicIds: theme.strategicIds,
            directoryId: theme.directoryId,
        };
    }

    return {
        page: location.pathname,
        isWhiteLabel: false,
    };
}
